import { render, staticRenderFns } from "./basic-info.vue?vue&type=template&id=13e9b204&scoped=true&"
import script from "./basic-info.vue?vue&type=script&lang=js&"
export * from "./basic-info.vue?vue&type=script&lang=js&"
import style0 from "./basic-info.vue?vue&type=style&index=0&id=13e9b204&prod&lang=scss&"
import style1 from "./basic-info.vue?vue&type=style&index=1&id=13e9b204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e9b204",
  null
  
)

export default component.exports